import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40f2ea08&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=40f2ea08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f2ea08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f2ea08')) {
      api.createRecord('40f2ea08', component.options)
    } else {
      api.reload('40f2ea08', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40f2ea08&scoped=true", function () {
      api.rerender('40f2ea08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/CostItem/index.vue"
export default component.exports